import { render, staticRenderFns } from "./BuildingEstimatesIndex.vue?vue&type=template&id=8c3ae748&"
import script from "./BuildingEstimatesIndex.vue?vue&type=script&lang=js&"
export * from "./BuildingEstimatesIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports